"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.core = void 0;
exports.core = {
    "addresses": {
        "ProxyAdmin": "0x30E148a79B898EFa1Ab1285F5Eca71972a7e0acE",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x16C7d1F9EA48F7DE5E8bc3165A04E8340Da574fA",
        "FeedPriceOracle": "0x15871f727bA0Db887ad8C736cC4F32C5B138E737",
        "CompLogic": "0xdD9C863197df28f47721107f94eb031b548B5e48",
        "RedemptionManager": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
        "Timelock": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
        "Comptroller": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
        "sdrCORE": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "CORE": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x60B8067Cf3640bCc7c3b2CfbE6Eac3c2CA40934e",
        "suErc20": "0xDb7Fe9c415281E383595c262e49568DDc18e8Bd4",
        "stCoreAdapter": "0xA70D0D01f34C70fdbc8A8e2A6651B0EDEbb945fb",
        "dualCoreAdapter": "0xE9b2f0c9c4868Db97623876191D268b53d9523f7",
        "JumpRate#StableBC": "0x98Ec4C9605D69083089eCAf353037b40017b758e",
        "JumpRate#Others": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
        "JumpRate#CORE": "0x1a9CFA6c676ebBEd450dB3cef03e399465F1202C",
        "ZeroRate": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
        "sdrUSDC": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
        "USDC": "0xa4151b2b3e269645181dccf2d426ce75fcbdeca9",
        "sdrUSDT": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
        "USDT": "0x900101d06a7426441ae63e9ab3b9b0f63be145f1",
        "sdrSolvBTC.b": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
        "SolvBTC.b": "0x5b1fb849f1f76217246b8aaac053b5c7b15b7dc3",
        "sdrSolvBTC.m": "0xf902e1925B50ac70285b73FD065af971487c2E4d",
        "SolvBTC.m": "0xe04d21d999faedf1e72ade6629e20a11a1ed14fa",
        "sdrSolvBTC.core": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
        "SolvBTC.core": "0x9410e8052bc661041e5cb27fdf7d9e9e842af2aa",
        "sdrBTCB": "0xddab3eb6028a44Fb31F9Da92eA1608809248B6b3",
        "BTCB": "0x7a6888c85edba8e38f6c7e0485212da602761c08",
        "sdrstCORE": "0x58235d9C8c9f136c0A4e9761186dB0329243bbB8",
        "stCORE": "0xb3a8f0f0da9ffc65318aa39e55079796093029ad",
        "sdrdualCORE": "0x45f7a835c5b490288ABE36CF3d25a1119135d60F",
        "dualCORE": "0xc5555ea27e63cd89f8b227dece2a3916800c0f4f",
        "sdrsuUSD": "0xaAC83D5E45A2f67f2bFd1B804776EFa7DAF6cbF6",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuBTC": "0xaE6388F58b5b35D5B2eEC828C9633E7D245FEf62",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xa4151b2b3e269645181dccf2d426ce75fcbdeca9",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x900101d06a7426441ae63e9ab3b9b0f63be145f1",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrSolvBTC.b",
            "ctokenAddr": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
            "underlySym": "SolvBTC.b",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x5b1fb849f1f76217246b8aaac053b5c7b15b7dc3",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrSolvBTC.m",
            "ctokenAddr": "0xf902e1925B50ac70285b73FD065af971487c2E4d",
            "underlySym": "SolvBTC.m",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe04d21d999faedf1e72ade6629e20a11a1ed14fa",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrSolvBTC.core",
            "ctokenAddr": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
            "underlySym": "SolvBTC.core",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x9410e8052bc661041e5cb27fdf7d9e9e842af2aa",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrBTCB",
            "ctokenAddr": "0xddab3eb6028a44Fb31F9Da92eA1608809248B6b3",
            "underlySym": "BTCB",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7a6888c85edba8e38f6c7e0485212da602761c08",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrstCORE",
            "ctokenAddr": "0x58235d9C8c9f136c0A4e9761186dB0329243bbB8",
            "underlySym": "stCORE",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xb3a8f0f0da9ffc65318aa39e55079796093029ad",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrdualCORE",
            "ctokenAddr": "0x45f7a835c5b490288ABE36CF3d25a1119135d60F",
            "underlySym": "dualCORE",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xc5555ea27e63cd89f8b227dece2a3916800c0f4f",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0xaAC83D5E45A2f67f2bFd1B804776EFa7DAF6cbF6",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xaE6388F58b5b35D5B2eEC828C9633E7D245FEf62",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrCORE",
            "ctokenAddr": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
            "underlySym": "CORE",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#CORE",
            "contract": "JumpRateModelV2",
            "address": "0x1a9CFA6c676ebBEd450dB3cef03e399465F1202C",
            "tokens": [
                "CORE",
                "CORE"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.08125",
            "jumpMultiplierPerYear": "4.675",
            "kink": "0.9"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x98Ec4C9605D69083089eCAf353037b40017b758e",
            "tokens": [
                "USDC",
                "USDT"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
            "tokens": [
                "SolvBTC.b",
                "SolvBTC.m",
                "SolvBTC.core",
                "BTCB",
                "stCORE",
                "dualCORE"
            ],
            "baseRatePerYear": "0.01",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
            "tokens": [
                "suUSD",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=core.js.map